import React, { useState, useEffect } from "react";
import "./Login.scss";

import { Button, Grid } from "@material-ui/core";
import Login_text_field from "../../../../Components/login/Login_text_field/Login_text_field";
import { validateEmail } from "../../../../Supporting files/HelpingFunction";
import { useNavigate } from "react-router-dom";
import { GenerateTokken, Post } from "../../../../Supporting files/CallAPI";
// import { GenerateTokken, Post } from "../../../../Supporting files/CallAPI";
import Session from "../../../../Session/Session";
import { URL_CONSTANTS } from "../../../../APIVar/URLConstants";
import RKTextField from "../../../../Supporting files/RKTextField/RKTextField";
import WarningIcon from "@mui/icons-material/Warning";

export default function Login() {
  const [signInStatus, setSignInStatus] = useState(true);
  const [forgetPassswordStatus, setForgetPasswordStatus] = useState(false);
  const [forgetPasswordSteps, setForgetPasswordSteps] = useState<number>(1);
  const [checkEmailStatus, setCheckEmailStatus] = useState(false);

  const [username, setUsername] = useState("");
  const [code, setCode] = useState("");
  const [createPassword, setCreatePassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [password, setPassword] = useState("");
  const [warnUsername, setWarnUsername] = useState(false);
  const [warnPassword, setWarnPassword] = useState(false);
  const [error, setError] = useState<any>({});
  const navigate = useNavigate();

  useEffect(() => {
    Session.setTokken("");
    Session.setUserType("");
    generate_tokken();
  }, []);

  function updateMasterState(attrName: any, value: string) {
    switch (attrName) {
      case setUsername:
        setUsername(value);
        setWarnUsername(value.toString().length > 0 ? false : true);
        break;
      case setPassword:
        setPassword(value);
        setWarnPassword(value.toString().length > 0 ? false : true);
        break;

      default:
        console.log(attrName, value);
        break;
    }
  }

  const validate_sign_in_form = () => {
    let warn_username =
      validateEmail(username.toString()) === true ? false : true;
    let warn_password = password.toString().length >= 6 ? false : true;

    setWarnUsername(warn_username);
    setWarnPassword(warn_password);

    if (warn_username === false && warn_password === false) {
      if (username === "employee@evervent.in" && password === "123456") {
        navigate("/home-employee");
      } else if (username === "broker@evervent.in" && password === "123456") {
        navigate("/homebroker");
      } else if (username === "employer@evervent.in" && password === "123456") {
        navigate("/homeemployer");
      }
      // call_sign_in_api();
    }
  };

  const call_sign_in_api = () => {
    let params = { username: username, password: password };
    Post(URL_CONSTANTS.login_via_username_password, params).then(
      (data: any) => {
        let status = data[0];
        let response = data[1];

        if (status === "success") {
          let user_token = response.userToken;

          localStorage.setItem("usertoken", user_token);
          navigate("/homebroker");

          window.location.reload();
        }
      }
    );
  };

  const generate_tokken = () => {
    GenerateTokken(URL_CONSTANTS.generate_tokken).then((data: any) => {
      let error = data[0];
      let response = data[1];

      if (error !== "failed") {
        let access_token = response.accessToken;
        localStorage.setItem("access_tokken", access_token);
      }
    });
  };

  //Forgot Password
  const validate_forgot_password_form = () => {
    let warn_username =
      validateEmail(username.toString()) === true ? false : true;
    setWarnUsername(warn_username);

    if (warn_username === false) {
      //call_forgot_password(username);
    }
  };
  // const call_forgot_password = (username: string) => {
  //   var params = { username: username };
  //   Post(URL_CONSTANTS.forgot_password, params).then((data: any) => {
  //     let error = data[0];
  //     let response = data[1];

  //     if (error == false) {
  //       setForgetPasswordStatus(false);
  //       setCheckEmailStatus(true);
  //     }
  //   });
  // };

  return (
    <Grid className="loginWrapper" container spacing={0}>
      <Grid item xs={5} className="leftcol">
        <img
          src={
            signInStatus == true
              ? "./images/login_bg.svg"
              : forgetPassswordStatus == true
                ? "./images/reset_password.svg"
                : "./images/check_email.svg"
          }
          alt="logo"
        />
      </Grid>
      <Grid item xs={7} className="formsection">
        {signInStatus == true ? (
          <div className="innerWrapper">
            <img
              src="images/benfit-care.svg"
              height="60px"
              style={{ marginBottom: "20px" }}
            />
            <h2>Login to your account</h2>
            <p className="mb-4">Please login using Username & Password</p>
            {/* <div className="error_display">
              <span> b
                <WarningIcon />
                Enter valid Username and Password
              </span>
            </div> */}

            <RKTextField
              class_name="inputField"
              title="User ID / E-mail"
              value={username}
              attrName={setUsername}
              value_update={updateMasterState}
              warn_status={warnUsername}
              error_messg={
                username.length === 0
                  ? "Please enter Email-ID."
                  : validateEmail(username) === false
                    ? "Please enter valid Email-ID"
                    : ""
              }
            />
            <RKTextField
              class_name="inputField mt-7"
              title="Password"
              value={password}
              attrName={setPassword}
              value_update={updateMasterState}
              warn_status={warnPassword}
              error_messg={
                password.length === 0
                  ? "Please enter password."
                  : password.length < 3
                    ? "Min. 3 Character Required"
                    : ""
              }
              password_status={true}
              type="password"
            />
            <p className="forgotpassword_link mb-4 mt-2">
              <Button
                color="primary"
                onClick={() => {
                  setSignInStatus(false);
                  setForgetPasswordStatus(true);
                  setUsername("");
                  setPassword("");
                }}
              >
                Forgot password?
              </Button>
            </p>
            <div className="ctaBtn">
              <Button
                className="submitBtn"
                size="large"
                type="submit"
                onClick={() => {
                  validate_sign_in_form();
                }}
              >
                Sign In
              </Button>
            </div>
          </div>
        ) : null}
        {forgetPassswordStatus == true ? (
          forgetPasswordSteps === 1 ? (
            <>
              <div className="innerWrapper">
                <h2>Reset your password</h2>
                <p>
                  Enter the email address associated with your account and we'll
                  send an email with instructions to reset your password.
                </p>

                <form noValidate className="formFields">
                  <RKTextField
                    class_name="inputField mt-7 mb-4"
                    title="Email"
                    value={username}
                    attrName={setUsername}
                    value_update={updateMasterState}
                    warn_status={warnUsername}
                  />
                  <div className="ctaBtn">
                    <Button
                      className="submitBtn"
                      size="large"
                      style={{ marginTop: "10px" }}
                      onClick={() => {
                        setForgetPasswordSteps(2);
                      }}
                    >
                      Send
                    </Button>
                  </div>
                  <p>
                    <Button
                      color="primary"
                      style={{ marginTop: "10px" }}
                      onClick={() => {
                        setSignInStatus(true);
                        setForgetPasswordStatus(false);
                        setUsername("");
                        setPassword("");
                      }}
                    >
                      I remember my password, take me back
                    </Button>
                  </p>
                </form>
              </div>
            </>
          ) : forgetPasswordSteps === 2 ? (
            <>
              {/* <p>Space for secret code, new passwor and confirm new password</p> */}
              <div className="innerWrapper">
                <h2>Check your Email</h2>

                <p>
                  We have sent a password recovery instruction to your email
                  exa**e@do***.com
                </p>
                <h6>{username}</h6>
                <form noValidate className="formFields">
                  <div className="ctaBtn">
                    <Button
                      className="submitBtn"
                      size="large"
                      style={{ marginTop: "10px" }}
                    >
                      Mail Info
                    </Button>
                  </div>
                </form>

                <p>
                  <Button
                    color="primary"
                    style={{ marginTop: "10px" }}
                    onClick={() => {
                      setForgetPasswordSteps(3);
                    }}
                  // onClick={() => {
                  //   setSignInStatus(true);
                  //   setForgetPasswordStatus(false);
                  //   setCheckEmailStatus(false);
                  //   setUsername("");
                  //   setPassword("");
                  // }}
                  >
                    Skip
                  </Button>
                </p>
                <p>
                  <Button
                    color="primary"
                    style={{ marginTop: "10px" }}
                    onClick={() => {
                      setCheckEmailStatus(false);
                      setForgetPasswordStatus(true);
                      setUsername("");
                      setPassword("");
                    }}
                  >
                    Another email address
                  </Button>
                </p>
              </div>
            </>
          ) : forgetPasswordSteps === 3 ? (
            <>
              {/* <p>Space for secret code, new passwor and confirm new password</p> */}
              <div className="innerWrapper">
                <h2>Verification Code</h2>

                <p>We have sent a secret code on your email</p>
                <h6>{username}</h6>
                <form noValidate className="formFields">
                  <RKTextField
                    class_name="inputField mt-10 mb-8"
                    title="Secret Code"
                    value={code}
                    attrName={code}
                    value_update={updateMasterState}
                    warn_status={warnUsername}
                  />

                  <div className="ctaBtn">
                    <Button
                      className="submitBtn"
                      size="large"
                      onClick={() => {
                        setForgetPasswordSteps(4);
                      }}
                    // onClick={() => {
                    //   validate_sign_in_form();
                    // }}
                    >
                      Verify
                    </Button>
                  </div>
                </form>

                <p>
                  <Button
                    color="primary"
                    style={{ marginTop: "20px" }}
                    onClick={() => {
                      setSignInStatus(true);
                      setForgetPasswordStatus(false);
                      setCheckEmailStatus(false);
                      setUsername("");
                      setPassword("");
                    }}
                  >
                    Didn't receive?
                  </Button>
                </p>
              </div>
            </>
          ) : forgetPasswordSteps === 4 ? (
            <>
              {/* <p>Confirmation Page</p> */}
              {/* {checkEmailStatus == true ? ( */}
              <div className="innerWrapper">
                <h2>Create new password</h2>
                <p>
                  Your new password must be different from previous used
                  passwords.
                </p>
                <h6>{username}</h6>
                <form noValidate className="formFields">
                  <RKTextField
                    class_name="inputField mt-10 mb-8"
                    title="Create Password"
                    value={createPassword}
                    attrName={createPassword}
                    value_update={updateMasterState}
                    warn_status={warnUsername}
                  />
                  <RKTextField
                    class_name="inputField mt-10 mb-8"
                    title="Confirm Password"
                    value={confirmPassword}
                    attrName={confirmPassword}
                    value_update={updateMasterState}
                    warn_status={warnUsername}
                  />
                  <div className="ctaBtn">
                    <Button
                      className="submitBtn"
                      size="large"
                      style={{ marginTop: "10px" }}
                      onClick={() => {
                        setForgetPasswordSteps(5);
                      }}
                    >
                      Submit
                    </Button>
                  </div>
                </form>
              </div>
              {/* ) : null} */}
            </>
          ) : forgetPasswordSteps === 5 ? (
            <>
              {/* <p>Confirmation Page</p> */}
              {/* {checkEmailStatus == true ? ( */}
              <div className="innerWrapper">
                <h2>Password has been reset</h2>
                <p>
                  Your password has been reset. Please login using the new
                  password.
                </p>
                <h6>{username}</h6>
                <form noValidate className="formFields">
                  <div className="ctaBtn">
                    <Button
                      className="submitBtn"
                      size="large"
                      style={{ marginTop: "10px" }}
                    >
                      Login again
                    </Button>
                  </div>
                </form>
              </div>
              {/* ) : null} */}
            </>
          ) : (
            <></>
          )
        ) : null}
        {checkEmailStatus == true ? (
          <div className="innerWrapper">
            <h2>Check your email</h2>
            <p>We have sent a secret code on your email</p>
            <h6>{username}</h6>
            <div className="ctaBtn">
              <Button
                className="submitBtn"
                size="large"
                style={{ marginTop: "10px" }}
              >
                Open mail
              </Button>
            </div>

            <p>
              <Button
                color="primary"
                style={{ marginTop: "10px" }}
                onClick={() => {
                  setSignInStatus(true);
                  setForgetPasswordStatus(false);
                  setCheckEmailStatus(false);
                  setUsername("");
                  setPassword("");
                }}
              >
                Skip
              </Button>
            </p>
            <p>
              <Button
                color="primary"
                style={{ marginTop: "10px" }}
                onClick={() => {
                  setCheckEmailStatus(false);
                  setForgetPasswordStatus(true);
                  setUsername("");
                  setPassword("");
                }}
              >
                Another email address
              </Button>
            </p>
          </div>
        ) : null}

        {/* <div className="innerWrapper d-none">
          <h2>Verification Code</h2>

          <p>We have sent a secret code on your email</p>
          <h6>{username}</h6>
          <form noValidate className="formFields">
            <RKTextField
              class_name="inputField mt-7 mb-4"
              title="Code"
              value={code}
              attrName={code}
              value_update={updateMasterState}
              warn_status={warnUsername}
            />
          
            <div className="ctaBtn">
              <Button
                className="submitBtn"
                size="large"
                onClick={() => {
                  validate_sign_in_form();
                }}>
                Verify
              </Button>
            </div>
          </form>

          <p>
            <Button
              color="primary"
              style={{ marginTop: "20px" }}
              onClick={() => {
                setSignInStatus(true);
                setForgetPasswordStatus(false);
                setCheckEmailStatus(false);
                setUsername("");
                setPassword("");
              }}>
              Didn't receive?
            </Button>
          </p>
        </div> */}
        <div>
          {/* {pageStatus === 2 ? ( */}
          {/* <Grid
              container
              spacing={2}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <Grid xs={12}>
                <svg
                  className="checkmark"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 52 52"
                >
                  <circle
                    className="checkmark__circle"
                    cx="26"
                    cy="26"
                    r="25"
                    fill="none"
                  />
                  <path
                    className="checkmark__check"
                    fill="none"
                    d="M14.1 27.2l7.1 7.2 16.7-16.8"
                  />
                </svg>
                <p className="quote_success text-center">
                  Your Query has been added successfully!
                </p>
              </Grid>
            </Grid> */}
          {/* ) : null} */}
        </div>
      </Grid>
    </Grid>
  );
}
